import { StorageType } from "./storage-type";
var StorageData = /** @class */ (function () {
    function StorageData(event, preventDefault, value, encrypt, storageType) {
        if (encrypt === void 0) { encrypt = true; }
        if (storageType === void 0) { storageType = StorageType.CACHE; }
        this._event = event;
        this.preventDefault = preventDefault;
        this.value = value;
        this.encrypt = encrypt;
        this.storageType = storageType;
    }
    Object.defineProperty(StorageData.prototype, "event", {
        get: function () {
            return this._event;
        },
        enumerable: true,
        configurable: true
    });
    return StorageData;
}());
export { StorageData };
//# sourceMappingURL=storage-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/storage/storage-data.js
// module id = 31
// module chunks = 14